import React from 'react';
import quimbombo1 from '../images/ilustrations/Anye_quimbombo1.svg';
import quimbombo2 from '../images/ilustrations/Anye_quimbombo2.svg';
import quimbombo3 from '../images/ilustrations/Anye_quimbombo3.svg';
import quimbombo4 from '../images/ilustrations/Anye_quimbombo4.svg';

const quimbombos = [
  { src: quimbombo1, left: '34%', top: '23%', width: 90, rotate: 15, delay: 0 },
  { src: quimbombo2, left: '41%', top: '13%', width: 110, rotate: -10, delay: 1.5 },
  { src: quimbombo3, left: '51%', top: '16%', width: 95, rotate: 45, delay: 0.5 },
  { src: quimbombo4, left: '60%', top: '20%', width: 130, rotate: -25, delay: 2.2 },
];

export default function DecorativeQuimbombo() {
  return (
    <div
      className="DecorativeQuimbombo"
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      {quimbombos.map((q, i) => (
        <img
          key={i}
          src={q.src}
          alt=""
          className="Quimbombo-item"
          style={{
            position: 'absolute',
            left: q.left,
            top: q.top,
            width: q.width,
            height: 'auto',
            objectFit: 'contain',
            transform: `rotate(${q.rotate}deg)`,
            animationDelay: `${q.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
